module.exports = __webpack_public_path__ + "static/media/new-debt.5acdd910.svg";